import { Company } from 'interfaces/company'
import BillingYourSubscription from './billing-your-subscription'
import BillingPaymentMethods from './billing-payment-method'
import BillingAddress from './billing-address'
import BillingHistory from './billing-history'
import { useState } from 'react'
import { Toaster } from 'lib/components/toast/toast'
import QueryClientProvider from 'providers/query-client-provider'
import { BillingPlansProvider } from './billing-plans-context'
import { BrightbackData } from 'lib/brightback/brightback'

export default function BillingPage({
  currentCompany,
  brightback,
}: {
  currentCompany: Company
  brightback: BrightbackData
}) {
  const [company, setCompany] = useState(currentCompany)

  return (
    <QueryClientProvider>
      <BillingPlansProvider company={company} brightback={brightback}>
        <Toaster />
        <div className="tw-container tw-flex tw-w-full tw-flex-col tw-px-3">
          <div className="tw-mb-4 tw-flex tw-justify-between">
            <h4>Manage Your Subscription</h4>
          </div>
          <div className="tw-mb-4 tw-flex tw-justify-between tw-gap-4">
            <BillingYourSubscription />
            <div className="tw-flex tw-w-full tw-flex-col tw-justify-between tw-gap-4">
              <div className="tw-h-1/2">
                <BillingPaymentMethods company={company} />
              </div>
              <div className="tw-h-1/2">
                <BillingAddress company={company} setCompany={setCompany} />
              </div>
            </div>
          </div>
          <BillingHistory />
        </div>
      </BillingPlansProvider>
    </QueryClientProvider>
  )
}
